import {useEffect, useState} from 'react';
import {setDataChanged} from '../service/completionState';

export type FormModelType = {
    [key: string]: FormModelField;
};

export type FormModelField = {
    value: any;
    error?: string;
    validationRules?: Array<(value) => string>;
};

export const resetFormChangesFlag = () => setDataChanged(false);

export const useForm = (formModel: FormModelType) => {
    const [formState, setFormState] = useState(formModel);
    const [isDirty, setFormDirtyState] = useState(false);

    useEffect(() => () => setDataChanged(false), []);

    function updateFormState(state) {
        setFormState(state);

        if (!isDirty) {
            setFormDirtyState(true);
            setDataChanged(true);
        }
    }

    function handleFieldError(value: any, name: string) {
        const {validationRules} = formState[name];
        let error = '';

        validationRules?.some(rule => {
            const errorMsg = rule(value);
            if (errorMsg) {
                error = errorMsg;
            }
            return Boolean(errorMsg);
        });
        return error;
    }

    function handleChange(value: any, name: string) {
        const error = handleFieldError(value, name);
        const currFieldData = formState[name];
        const updatedState = {
            ...formState,
            [name]: {
                ...currFieldData,
                value,
                error
            }
        };
        updateFormState(updatedState);
    }

    const isFormValid = Object.keys(formState).every(field => {
        const {value, error} = formState[field];

        return !Boolean(error || handleFieldError(value, field));
    });

    return {formState, isFormValid, handleChange, isDirty, setFormDirtyState, updateFormState};
};
